var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperLifestyleActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,1.785a15,15,0,1,1-15,15A15,15,0,0,1,16.3,1.785Z",
    transform: "translate(-1.296 -1.785)",
    fill: "#778eef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7,17.679h0a.869.869,0,0,1-.48-.1c-.03-.027-.068-.057-.109-.089-.162-.128-.363-.288-.318-.425l1.981-6.491L.432,10.553A.43.43,0,0,1,0,10.115.474.474,0,0,1,.094,9.83C.958,8.754,1.745,7.65,2.507,6.582S4.056,4.409,4.919,3.334C5.722,2.32,6.557,1.289,7.364.292L7.491.136A.626.626,0,0,1,7.957,0a.917.917,0,0,1,.51.121l.059.052c.153.132.363.312.313.463L6.858,6.683l5.4.019c.232,0,.8.292.8.546,0,.032,0,.077.006.133.007.116.017.274.015.487C11.426,10.04,9.652,12.208,7.935,14.3l-.069.084c-.827,1-1.682,2.04-2.559,3.133A.909.909,0,0,1,4.7,17.679ZM6.946,2.748,5.97,3.967C5.2,4.918,4.6,5.787,4.019,6.628S2.837,8.337,2.068,9.288l4.86.019a.519.519,0,0,1,.169.019.427.427,0,0,1,.255.217.467.467,0,0,1,.027.354L5.763,14.969c.168-.209.344-.421.515-.626l0,0c.171-.206.347-.419.516-.628C8.273,11.927,9.85,10,11.377,8.021L5.782,8a.519.519,0,0,1-.169-.019.426.426,0,0,1-.255-.217.467.467,0,0,1-.027-.355Z",
    transform: "translate(8.096 6.405)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperLifestyleActiveIcon);
export default __webpack_public_path__ + "static/media/swiper_lifestyle_active_icon.1d5eefaa.svg";
export { ForwardRef as ReactComponent };